import { loadObjectAttrinbutesAll } from "src/pages/ManagementPage/objectsApi";

export const loadSizeLineAttrNameId = async (
  objSizeLineId: number | string | null | undefined,
): Promise<string> => {
  if (typeof objSizeLineId !== "string") return "";
  const attrs = await loadObjectAttrinbutesAll(objSizeLineId);
  const nameAttr = attrs.find(({ fieldKey }) => fieldKey === "NAME");
  const id = nameAttr?.id;
  return typeof id === "string" ? id : "";
};
